<div class="container-fluid header-distinction p-4">
    <div class="row">
        <div class="col-sm-12">
            <h2 class="text-center w-100">Top Cities</h2>
        </div>
    </div>
</div>
<div class="container mt-5">
    <div class="row">
        <div class="col-sm-12">
            <h4>Search Location</h4>
        </div>
    </div>
    <div class="row my-4 p-3 with-background">
        <div class="col-lg-3 my-2">
            <select class="form-control" [formControl]="province_id" (change)='onProvinceSelected($event.target.value)'>
                <option value="null" disabled [selected]="true">Choose the province</option>
                <option *ngFor="let province of provinceList" [value]="province.id">{{ province.province }}</option>
            </select>
        </div>
        <div class="col-lg-3 my-2">
            <select class="form-control" [formControl]="district_id" (change)="onDistrictSelected($event.target.value)">
                <option value="null" disabled [selected]="true">Choose the district</option>
                <option *ngFor="let district of validDistrictList" [value]="district.id">{{ district.district }}</option>
            </select>
        </div>
        <div class="col-lg-3 my-2">
            <select class="form-control" [formControl]="municipality_id" (change)="onMunicipalitySelected($event.target.value)">
                <option value="null" disabled [selected]="true">Choose the municipality</option>
                <option *ngFor="let municipality of validMunicipalityList" [value]="municipality.id">{{ municipality.municipality }}</option>
            </select>
        </div>
        <div class="col-lg-3 my-2">
            <button class="theme-button" (click)="searchLocation()">Search</button>
        </div>
    </div>
</div>
<div class="container mb-5 pb-3">
    <div class="row pt-4 pb-4">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 rounded" *ngFor="let location of majorLocations">
            <div class="container-location">
                <img class="location-image" [src]="location.imagePath" />
                <div class="mask"></div>
                <p class="location"><a [routerLink]="location.route">{{ location.name }}</a></p>
            </div>  
        </div>
    </div>
</div>